import { useNavigate } from "react-router-dom";
import { SparklesIcon } from "@heroicons/react/24/solid";

export default function ImageToRecipePromo() {
  const navigate = useNavigate();

  return (
    <div
      onClick={() => navigate("/chat")}
      className="relative bg-slate-900 text-white rounded-2xl overflow-hidden flex items-center justify-between p-4 sm:p-6 cursor-pointer hover:scale-[1.02] transition-transform duration-200 shadow-lg"
    >
      {/* Left: Text + Sparkle */}
      <div className="z-10 flex-1">
        <h2 className="text-lg sm:text-xl font-extrabold leading-snug">
          Turn your photos into recipes
        </h2>
        <p className="text-sm sm:text-base text-slate-300 mt-1">
          Recreate any meal you see
        </p>
        <div className="mt-3 flex items-center gap-2 text-white font-semibold text-sm underline">
          <SparklesIcon className="h-5 w-5 text-white" />
          Try it now
        </div>
      </div>

      {/* Right: Image */}
      <div className="block relative w-28 h-28 flex-shrink-0  rounded-xl overflow-hidden z-0 rotate-17">
        <img
          src="/assets/recipe-search.png"
          alt="Generated dish"
          className="w-full h-full object-cover"
        />

        {/* Floating sparkle effect */}
        <div className="absolute -top-2 -right-2 bg-slate-800 rounded-full p-1 shadow-lg animate-pulse">
          <SparklesIcon className="h-5 w-5 text-sage" />
        </div>
      </div>

      {/* Background glow */}
      <div className="absolute inset-0 bg-gradient-to-br from-white/5 via-slate-900/10 to-transparent pointer-events-none" />
    </div>
  );
}
